import { render, staticRenderFns } from "./contract-linkcard.vue?vue&type=template&id=d04c1e84&scoped=true"
import script from "./contract-linkcard.vue?vue&type=script&lang=js"
export * from "./contract-linkcard.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style-review.css?vue&type=style&index=0&id=d04c1e84&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04c1e84",
  null
  
)

export default component.exports